unit Main;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset, MobileForm,
  XData.Web.Dataset, XData.Web.Connection, WEBLib.DB, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.EditAutocomplete,
  WEBLib.Grids, WEBLib.ExtCtrls, WEBLib.JQCtrls, WEBLib.JQGrid, Vcl.Forms,
  Vcl.Imaging.pngimage, XData.Web.Client, Constants;

type
  TfrmMain = class(TForm)
    panMain: TPanel;
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
    procedure ClearForm;
  public
    { Public declarations }
//    frm: TMobileForm;
    frm: TForm;
    FormPrevious: string;
    FormCurrent: string;

    procedure ShowLogin;
    procedure ShowNarocila;
    procedure ShowNalog;
    procedure ShowNalogInfo(NalogId: integer);

    procedure ShowRegistracija(Nacin: TGesloNacin);
  protected procedure LoadDFMValues; override; end;

var
  frmMain: TfrmMain;

implementation

{$R *.dfm}

uses Client.Core, Client.Settings, Auth.Service, Login, Narocila, Narocilo, MenjavaGesla, NarociloInfo;

procedure TfrmMain.ClearForm;
begin
  if Assigned(frm) then begin
    FormPrevious := frm.ClassName;

    modMain.Log('FormPrevious='+FormPrevious);
    frm.Close;
    frm := nil;
  end;
end;

procedure TfrmMain.ShowLogin;
begin
  ClearForm;
  frm := TfrmLogin.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowNalog;
begin
  ClearForm;
  frm := TfrmNarocilo.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowNalogInfo(NalogId: integer);
  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmNarociloInfo).NalogId := NalogId;
  end;
begin
  ClearForm;
  frm := TfrmNarociloInfo.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowNarocila;
begin
  ClearForm;
  frm := TfrmNarocila.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowRegistracija(Nacin: TGesloNacin);

  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmMenjavaGesla).MenjavaGesla := Nacin;
  end;

begin
  ClearForm;
  frm := TfrmMenjavaGesla.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.WebFormCreate(Sender: TObject);
begin
  Application.ErrorType := aeSilent;

  Frm := nil;
  ShowLogin;
end;

procedure TfrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panMain := TPanel.Create(Self);

  panMain.BeforeLoadDFMValues;
  try
    Name := 'frmMain';
    Width := 668;
    Height := 761;
    Align := alClient;
    Caption := 'Kamijon'#269'in';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    panMain.SetParentComponent(Self);
    panMain.Name := 'panMain';
    panMain.Left := 0;
    panMain.Top := 0;
    panMain.Width := 668;
    panMain.Height := 761;
    panMain.Align := alClient;
    panMain.BorderColor := clWhite;
    panMain.BorderStyle := bsNone;
    panMain.ChildOrder := 2;
    panMain.Color := clWhite;
    panMain.ElementFont := efCSS;
    panMain.ShowCaption := False;
    panMain.TabOrder := 0;
  finally
    panMain.AfterLoadDFMValues;
  end;
end;

end.
